import React, { useState } from 'react'
import SafeDateRange from './SafeDateRange'

interface CustomDateRangePickerProps {
  state: any;
  handleCustomDateChange: (item: any) => void;
  [key: string]: any;
}

const CustomDateRangePicker = ({ state, handleCustomDateChange, ...rest }: CustomDateRangePickerProps) => {
    const [error, setError] = useState<string | null>(null);

    const handleChange = (item: any) => {
        try {
            handleCustomDateChange(item);
        } catch (err) {
            console.error('Error in CustomDateRangePicker handleChange:', err);
            setError('Date picker error occurred');
        }
    };

    // Error boundary for the component
    if (error) {
        return (
            <div className="alert alert-danger">
                <strong>Error:</strong> {error}
                <button 
                    className="btn btn-sm btn-outline-danger ms-2"
                    onClick={() => setError(null)}
                >
                    Retry
                </button>
            </div>
        );
    }

    return (
        <>
            <SafeDateRange
                ranges={state}
                onChange={handleChange}
                {...rest}
            />
        </>
    )
}

export default CustomDateRangePicker